module.exports = __webpack_public_path__ + "static/img/banner-two.93c1008.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-two.png
// module id = ELoP
// module chunks = 34